module.exports = __webpack_public_path__ + "img/logo.4b20a943.png";